import axios from 'axios';
import { useCookies } from 'vue3-cookies';
import { setAllCookies, refreshTokenIsValid } from '@/services/utils';
import loginRepository from '@/api/LoginRepository';
import { useToast } from 'vuestic-ui';

const { cookies } = useCookies();
const { init: notify } = useToast();

// interface ApiErrorResponse {
//   detail: string;
//   status: HttpStatusCode;
//   title: string;
//   type: string;
// }

export const CookiesName = {
  token: 'accessToken',
  tokenExpiresAt: 'tokenExpiresAt',
  refreshToken: 'refreshToken',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  adminData: 'admin',
};
const api = axios.create({
  baseURL: import.meta.env.PROD ? import.meta.env.VITE_API_URL : '',
  // withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  // sanitize
  Object.keys(config.params || {}).map((key) => {
    if (
      config.params[key] === undefined ||
      config.params[key] === null ||
      (typeof config.params[key] === 'string' &&
        !(config.params[key] as string).length)
    ) {
      delete config.params[key];
    }
  });

  // получение токена
  const token = cookies.get(CookiesName.token);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response.data.data,
  async (error) => {
    if (error?.response?.status === 401 && !error.config.url.includes('Refresh') && !error.config.url.includes('SignIn')) {
      cookies.remove(CookiesName.token);
      if (refreshTokenIsValid()) {
        try {
          const response = await loginRepository.refresh(
            cookies.get(CookiesName.refreshToken),
          );
          setAllCookies(response);
          error.config.headers = error.config.headers || {};
          error.config.headers.Authorization = `Bearer ${cookies.get(
            CookiesName.token,
          )}`;
          const newResponse = await axios(error.config);
          return Promise.resolve(newResponse.data.data);
        } catch (error) {
          cookies.remove(CookiesName.refreshToken);
          return Promise.reject(error);
        }
      } else {
        cookies.remove(CookiesName.refreshToken);
        window.location.reload();
      }
    } else if (error.config.url.includes('refresh')) {
      cookies.remove(CookiesName.refreshToken);
      window.location.reload();
    } else {
      notify({
        message: error.response?.data?.title || 'Произошла ошибка',
        color: 'danger',
      });
    }
    return Promise.reject(error);
  },
)

export default api;
